import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InProgressFormsListComponent } from '../../components/in-progress-forms-list/in-progress-forms-list.component';

@Component({
  selector: 'app-all-forms-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    InProgressFormsListComponent
  ],
  templateUrl: './all-forms-page.component.html',
  styleUrl: './all-forms-page.component.scss'
})
export class AllFormsPageComponent {

}
